define('lib/validator/ValidatorIntlPhone',['require','lib/validator/ValidatorAbstract','Config'],function (require) {
	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	var Config = require('Config');

	return ValidatorAbstract.extend({
		errorMap: {
			0: "Invalid number",
			1: "Invalid country code",
			2: "Too short",
			3: "Too long",
			4: "Invalid number",
			'-99': "error_value_is_empty"
		},

		validate: function (value) {
			if (window.intlTelInput) {
				const phoneInput = document.createElement("input");

				//this is a workaround for the case when lib needs import utils.js,
				// but compiler doesn't support new JS syntax
				//so, in base64 encoded global function loadUtilsFunction with return import utils.js
				if(!window.loadUtilsFunction) {
					eval(atob("d2luZG93LmxvYWRVdGlsc0Z1bmN0aW9uID0gZnVuY3Rpb24gKCkgewogICAgcmV0dXJuIGltcG9ydCgiL3YyL2xpYi9pbnRsLXRlbC1pbnB1dC9qcy91dGlscy5qcz92PTMiKTsKfQ=="));
				}

				const iti = window.intlTelInput(phoneInput, {
					initialCountry: "auto",
					//loadUtilsOnInit: "/v2/lib/intl-tel-input/js/utils.js",
					loadUtils: window.loadUtilsFunction,
					validationNumberTypes: null,//"FIXED_LINE_OR_MOBILE",
				});
				iti.setNumber(value);

				if (!iti.isValidNumber() && !_.isEmpty(value)) {
					this.handleValidationError(iti.getValidationError(), value);
				}
			} else if (window.intlTelInput && window.intlTelInput.utils) {
				if (!window.intlTelInput.utils.isPossibleNumber(value) && !_.isEmpty(value)) {
					this.handleValidationError(window.intlTelInput.utils.getValidationError(value), value);
				}
			} else {
				this.validateWithoutIntlTelInput(value);
			}

			if (!this.getErrors().length && this.options.allowedPrefix && !_.isEmpty(value)) {
				this.validatePrefix(value);
			}
		},

		handleValidationError: function (errorCode, value) {
			if (this.shouldIgnoreError(value)) return;

			var errorMsg = this.errorMap[errorCode] || this.errorMap[0];
			this.addError(errorMsg);
		},

		shouldIgnoreError: function (value) {
			return this.options.allowedPrefix && this.options.checkPhoneRequired && !this.isPhoneRequired() &&
				String(value).trim().replace('+', '') === this.options.allowedPrefix ||
				!this.isPhoneRequired() && _.isEmpty(String(value).trim());
		},

		validateWithoutIntlTelInput: function (value) {
			console.warn('intlTelInputUtils not loaded');
			var regexp = /^\+?[\d\s\-]{7,16}$/;
			if (!_.isEmpty(value) && !regexp.test(value)) {
				this.addError('error_value_is_not_phone');
			}
		},

		validatePrefix: function (value) {
			var prefix = String(this.options.allowedPrefix).replace(/^\D+/g, '');
			var phone = String(value).replace(/^\D+/g, '');
			if (phone.indexOf(prefix) !== 0) {
				this.addError("This country prefix not allowed");
			}
		},

		isPhoneRequired: function () {
			var config = Config.getInstance();
			var getParam = config.getParam || config.getOption;
			return config.getPluginStatus('client_login') ?
				parseInt(getParam('client_login_require_phone')) === 1 :
				getParam('client_phone_required');
		}
	});
});
